import Fade from "react-reveal";
import { useNavigate } from "react-router-dom";
import { Button, Container, Form } from "reactstrap";
import "rsuite/dist/rsuite.min.css";

import CustomPagination from "Component/common/CustomPagination";
import SearchFilter from "Component/common/SearchFilter";
import TableActions from "Component/common/TableActions";
import TableLayout from "Component/common/TableLayout";
import dataHandler from "hooks/dataHandler";
import moment from "moment";
import {
  MANAGE_CATEGORY,
  GET_CATEGORY_LIST,
  DELETE_CATEGORY,
} from "services/ApiCalls";
import Plussvg from "../../../../assets/svg/plussvg.svg";
import TableProfile from "Component/common/TableLayout/TableProfile";
import DeleteModal from "../DeleteModal";
import { ReactComponent as Deletesvg } from "assets/svg/deletesvg.svg";
import { useSelector } from "react-redux";
import { useState } from "react";
import { PERMISSION_KEYS } from "utilities/permissionConst";
import usePermissions from "hooks/usePermissions";

const CategoryTable = () => {
  const navigate = useNavigate();
  const permission = usePermissions({ permissionKey: PERMISSION_KEYS.CATEGORY_PERMISSION });

  const {
    body,
    deleteModel,
    setDeleteModel,
    paginationHandler,
    total,
    loader,
    setBody,
    data,
    refetch,
  } = dataHandler({
    api: GET_CATEGORY_LIST,
    extraBody: { orderBy: "name", order: 1 },
    dataToSet: (data) => data?.data?.data,
  });

  const [deleting, setDeleting] = useState(false);

  // -------------------------------
  // DELETE HANDLER
  // -------------------------------
  const confirmDelete = async () => {
    if (!deleteModel.id) return;

    try {
      setDeleting(true);
      const res = await DELETE_CATEGORY({
        _id: deleteModel.id,
      });

      if (res?.status === 200) {
        refetch();
      }
    } catch (err) {
      console.error(err);
    } finally {
      setDeleting(false);
      setDeleteModel({ show: false, id: null });
    }
  };

  // -------------------------------
  // Table Columns
  // -------------------------------
  const col = [
    {
      head: "Icon",
      accessor: "icon",
      component: (item) => <TableProfile image={item?.icon} />,
    },
    {
      head: "Category",
      accessor: "name",
    },
    {
      head: "Type",
      accessor: "type",
      component: (item) => {
        if (item?.type === 0) return "PITCH";
        if (item?.type === 3) return "EVENTS";
        return "-";
      },
    },

    {
      head: "Created At",
      accessor: "createdAt",
      component: (item) => moment(item?.createdAt).format("YYYY/MM/DD HH:mm"),
    },
  ];

  // Actions
  if (permission?.isAdd || permission.isDelete) {
    col.push({
      head: "Action",
      accessor: "",
      component: (item) => (
        <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
          <TableActions editLink={`/edit-category/${item?._id}`} deleteHandler={() => setDeleteModel({ show: true, id: item._id })} permissionKey={PERMISSION_KEYS.CATEGORY_PERMISSION} />
        </div>
      ),
    });
  }

  return (
    <Fade>
      <section className="dashboard_first comon_dashpad">
        <Form>
          <div className="comom_fillter_set text-start">
            <div className="resource_headwrap d-flex align-items-center justify-content-between">
              <h3 className="fillter_head">Manage Category</h3>
            </div>

            <div className="fillter_form_wrap d-flex align-items-center gap-3 justify-content-between mt-4">
              <div className="fillter_area d-flex">
                <div className="fillter_by d-flex align-items-center gap-3">
                  <h5>Filter by :</h5>
                  <div className="search_form d-flex align-items-center gap-3">
                    <SearchFilter body={body} setBody={setBody} />
                  </div>
                </div>
              </div>

              {(permission?.isAdd ?? true) && (
                <div className="export_btn d-flex align-items-center gap-3">
                  <Button
                    className="plussvg"
                    onClick={() => navigate("/add-category")}
                  >
                    <img src={Plussvg} alt="add" className="img-fluid" />
                  </Button>
                </div>
              )}
            </div>
          </div>
        </Form>

        <div className="manageuser_tabbingset mt-5">
          <section className="tabbing_common">
            <div className="tab-frame user_frame">
              <div className="manageuser_tabbingset mt-4">
                <section className="Diagnosis_table com_table">
                  <Container>
                    <TableLayout
                      data={data}
                      column={col}
                      loader={loader}
                      body={body}
                    />

                    <div className="pagination_list d-flex align-items-center gap-3 justify-content-end py-3">
                      <CustomPagination
                        total={total}
                        body={body}
                        setBody={setBody}
                        pageChangeHandler={paginationHandler}
                      />
                    </div>
                  </Container>
                </section>
              </div>
            </div>
          </section>
        </div>
      </section>

      <DeleteModal
        isOpen={deleteModel.show}
        toggle={() => setDeleteModel({ show: false, id: null })}
        onDelete={confirmDelete}
        title="Are you sure you want to delete this category?"
        loading={deleting}
      />
    </Fade>
  );
};

export default CategoryTable;
